// removed by extract-text-webpack-plugin
module.exports = {"link":"_1CLy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HoverLink/styles.scss
// module id = 322
// module chunks = 0